import Component from '../app/component'
import gsap from 'gsap'

export default class LoaderComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    document.body.classList.add('unscrollable')
      // console.log('var')

    if (sessionStorage.getItem('loaderIgnore')) {
      this.remove()
      return
    }

    setTimeout(() => sessionStorage.setItem('loaderIgnore', '1'), 1)

    Promise.resolve()
      .then(() => this.tween())
      .then(() => this.remove())
  }

  tween () {
    const tl = gsap.timeline()
    this.el.style.opacity = 1

    tl.to(
      this.refs.progressBar,
      {
        scaleX: 1,
        duration: 2.5,
        ease: 'expo.inOut'
      },
      0.5
    )

    tl.to(
      this.el,
      {
        opacity: 0,
        duration: 1.2,
        ease: 'power1.out'
      },
      3.5
    )

    return tl.then()
  }

  remove () {
    document.body.classList.remove('unscrollable')
    this.el.parentNode.removeChild(this.el)
    document.dispatchEvent(new CustomEvent('loader.end'))
  }
}
